import { get, isArray } from 'lodash';
import { Schema } from 'normalizr';

import { ApiFlaggedAction } from '../middlewares/api-middleware';
import { FreeShapeAction } from '../types';
import { NORMALISATION_FLAGS } from './constants';

/**
 * Get a schema's key from schema object.
 *
 * @param {Schema} schema
 * @returns {string}
 */
export const getSchemaEntityKey = (schema: Schema) => isArray(schema) ? get(schema, '[0]._key') : get(schema, '_key');

/**
 * Checks if the given action has a meta.noramlisation flag indicating an action
 * that needs to be performed on the normalised store.
 *
 * @param {FreeShapeAction} action
 * @returns {boolean}
 */
export const hasNormalisationAction = (action: FreeShapeAction): boolean => [...Object.keys(NORMALISATION_FLAGS)].includes(get(action, 'meta.normalisation'));

/**
 * Utility to break down an api action to useful things for a normalisation action.
 * This may seem a little fragile on its own, but each of the properties are guarenteed
 * to exist by checks outside of this function.
 *
 * @param {ApiFlaggedAction} action
 * @returns {string[]}
 */
export const parseActionForNormalisation = (action: ApiFlaggedAction): string[] => [
  get(action, 'meta.normalisation'),
  getSchemaEntityKey(get(action, 'meta.schema')),
  get(action, 'payload.request.url')
];

/**
 * Utility for lodash's `merge` which will overide merging arrays and return whatever
 * the provided new value is.
 *
 * @param {unknown} object
 * @param {unknown} src
 * @returns {unknown}
 */
export const mergeWithCustomiser = (object: unknown, src: unknown) => {
  if (isArray(object)) {
    return src;
  }
};
